import React, { Component } from "react";
import I18n from "../../../i18n/I18n";
import Helper from "../../../helper/Helper";
import { Icon, ToggleButton } from "../../common";
import styles from "./PaymentHistory.scss";
import ItemGlobalCard from "./ItemGlobalCard";
import SalesOverview from "./SalesOverview";

type Props = {
  statements: Array<Object>,
  currencyCode: string
};

type State = {
  currentStatement: Object,
  progress: number // 1: current, further:.... sorted on the basis of date
};

class PaymentHistory extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      currentStatement: props.statements[0] || undefined,
      progress: props.statements && props.statements.length ? 1 : 0
    };
  }

  toggleStatement = statement => {
    this.setState({
      currentStatement: statement,
      progress:
        this.props.statements.findIndex(
          statementObject => statementObject === statement
        ) + 1
    });
  };
  render() {
    const { statements, currencyCode } = this.props;
    const { currentStatement, progress } = this.state;
    const statementList =
      statements && statements.length
        ? statements.map((statement, index) => {
            let title = I18n.getText("sales.current-payment", {}, "Current");
            const subtitle =
              statement.delta_net_due && statement.delta_net_due !== 0
                ? I18n.formatCurrency(
                    Helper.formatPrice(statement.delta_net_due, currencyCode)
                  )
                : "-";
            if (statement.statement_nr) {
              title = statement.statement_nr;
            }
            return (
              <div
                key={index}
                className={`${styles.eachStatement} ${
                  currentStatement === statement ? styles.selected : ""
                }`}
                onClick={() => this.toggleStatement(statement)}
              >
                <div className={styles.name}>{title}</div>
                <div
                  className={`${styles.amountDue} ${
                    statement.delta_net_due && statement.delta_net_due > 0
                      ? styles.positive
                      : statement.delta_net_due < 0 ? styles.negative : ""
                  }`}
                >
                  {subtitle}
                </div>
              </div>
            );
          })
        : "";

    const saleData = currentStatement
      ? {
          header: I18n.getText("sales.sale-data"),
          details: [
            {
              label: I18n.getText("sales.shipped-date"),
              value: currentStatement.shipped_date
            },
            {
              label: I18n.getText("sales.statement-nr"),
              value: currentStatement.statement_nr || "-",
              link: currentStatement.statement_nr
                ? `/${Helper.getLocale()}/statements/${currentStatement.statement_nr}`
                : ""
            },
            {
              label: "Statement Status",
              value: currentStatement.current_status || "-"
            }
          ]
        }
      : {};
    if (currentStatement.sla_code !== "legacy") {
      saleData.details.push(
        {
          label: I18n.getText("sales.return-ndr-due"),
          value: currentStatement.return_ndr_due_date || "-"
        },
        {
          label: I18n.getText("sales.return-cir-due"),
          value: currentStatement.return_cir_due_date || "-"
        }
      );
    }
    const commissionData = {
      header: I18n.getText("sales.commission-data"),
      details: [
        {
          label: I18n.getText("sales.sla-type"),
          value: currentStatement.sla_name
        },
        {
          label: I18n.getText("sales.product-type"),
          value: currentStatement.product_fulltype_code
            ? currentStatement.product_fulltype_code
                .replace(/\./g, " ")
                .replace(/_/g, " / ")
            : ""
        },
        {
          label: I18n.getText("sales.commission-type"),
          value: currentStatement.commission_name
        },
        {
          label: I18n.getText("sales.commission-rate"),
          value: currentStatement.commission_rate + "%"
        },
        {
          label: I18n.getText("sales.fee-discount-promotion"),
          value: currentStatement.output_tags
        }
      ]
    };
    return (
      <div className={styles.flexView}>
        <div className={styles.side}>{statementList}</div>
        <div className={styles.main}>
          <SalesOverview
            subheader={I18n.getText("sales.statement-breakdown")}
            deltaEnabled={true}
            pendingItem={currentStatement}
            saleData={currentStatement && saleData}
            commissionData={commissionData}
            currencyCode={currentStatement.currency_code}
          />
        </div>
      </div>
    );
  }
}
export default PaymentHistory;



// WEBPACK FOOTER //
// ./src/components/sales/salesDetails/PaymentHistory.js